/**
 * New typescript file
 */
import { TopNavComponent } from './topnav/topnav';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { Ng2BootstrapModule } from 'ng2-bootstrap';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    FormsModule,
    Ng2BootstrapModule.forRoot(),
    ReactiveFormsModule
  ],
  declarations: [TopNavComponent],
  exports: [TopNavComponent],
})
export class SharedModule { }


// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts